<script>
    import { fly } from "svelte/transition";
    import {
        Arrow,
        ArrowFill,
        Help,
        Backspace,
        Minus,
        Plus,
        Settings,
        StarFill,
    } from "../index";
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <Arrow />
        <ArrowFill />
        <Help />
        <Backspace />
        <Minus />
        <Plus />
        <Settings />
        <StarFill />
    </div>
    <h4 class="example-title">大小</h4>
    <div class="example-body">
        <Help size={24} />
        <Help size={32} />
        <Help size={48} />
    </div>
    <h4 class="example-title">颜色</h4>
    <div class="example-body">
        <Help size={24} color="red" />
        <Help size={32} color="green" />
        <Help size={48} color="blue" />
        <StarFill size={60} color="blue" />
    </div>
    <h4 class="example-title">更多的图标</h4>
    <div class="example-body">
        <a target="_blank" href="https://heroicons.com/">heroicons</a>
    </div>
</div>

<style lang="less">
    @import "./example.less";
</style>
